<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options"/>

    <basic-table
      v-if="ipGroupsItems"
      :items="ipGroupsItems"
      :fields="ipGroupsFields"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"/>
    <table-manager-bottom
    :totalRows="totalRows" :perPage="perPage"
    v-model="currentPage" />
  </div>
</template>

<script>
export default {
  data () {
    return {
      options: {
        isShowAddButton: false
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      ipGroupsFields: [
        {key: 'ipgroup_id', label: 'ID', sortable: true},
        {key: 'slink_id', label: this.$i18n.t('Service link ID'), sortable: true},
        {key: 'ip', label: this.$i18n.t('IP'), sortable: true},
        {key: 'mask', label: this.$i18n.t('Mask'), sortable: true},
        {key: 'mac', label: this.$i18n.t('MAC'), sortable: true},
        {key: 'login', label: this.$i18n.t('Customer name'), sortable: true},
        {key: 'allowed_cid', label: this.$i18n.t('Allowed CID'), sortable: true}
      ]
    }
  },
  methods: {
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    ipGroupsItems () {
      let tmp = []
      for (let el of this.$store.getters['Users/IP_GROUPS']) {
        let newEl = {
          ipgroup_id: el.ipgroup_id,
          slink_id: el.slink_id,
          ip: el.items[0].ip,
          mask: el.items[0].mask,
          mac: el.items[0].mac,
          login: el.items[0].login,
          allowed_cid: el.items[0].allowed_cid
        }
        tmp.push(newEl)
      }
      return tmp
    }
  },
  mounted () {
    this.$store.dispatch('Users/GET_IP_GROUPS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/network/ipgroups/main.vue